import { err, got, req } from "../slices/systemNotificationSettingsSlice";
import accountsDataService from "features/Accounts/services/accountsDataService";
import { type EditSystemNotificationSettingsRequest, type SystemNotificationSetting } from "features/Accounts/types";
import { type AppDispatch } from "features/Application/globaltypes/redux";

export const fetchSystemNotificationSettings = (accountId: number) => async (dispatch: AppDispatch) => {
  dispatch(req());
  try {
    const settings = await accountsDataService.getSystemNotificationSettings(accountId);
    dispatch(got(settings));
  } catch (e) {
    dispatch(err(new Error(e.message)));
  }
};

export const updateSystemNotificationSetting =
  (accountId: number, setting: SystemNotificationSetting) => async (dispatch: AppDispatch) => {
    dispatch(req());
    try {
      const payload: EditSystemNotificationSettingsRequest = {
        notificationStatuses: [
          {
            notificationTypeId: setting.notificationTypeId,
            isEnabled: setting.isEnabled,
          },
        ],
      };
      await accountsDataService.updateSystemNotificationSettings(accountId, payload);
    } catch (e) {
      dispatch(err(new Error(e.message)));
    } finally {
      await fetchSystemNotificationSettings(accountId)(dispatch);
    }
  };
